import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "CalendarNotificationBar" */ './lazyIndex')
);

export {
    CalendarNotificationOptions,
    CalendarNotificationButtonOptions,
    CalendarNotificationCallbackOptions,
    CustomNotificationBarCallbackReason,
    CalendarNotificationBarCallbackReason,
} from './schema/CalendarNotificationInterfaces';

export { NotificationBarCallbackReason, NotificationBarHost } from 'owa-notification-bar';

// Lazy-load actions
export let lazyShowCalendarNotification = new LazyImport(lazyModule, m => m.showNotification);
export let lazyShowCalendarNotificationWithButtonCallback = new LazyImport(
    lazyModule,
    m => m.showNotificationWithButtonCallback
);
export let lazyDismissCalendarNotification = new LazyImport(lazyModule, m => m.dismissNotification);
export let lazyEnableNotificationBar = new LazyImport(lazyModule, m => m.enableNotificationBar);
